var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRangeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 31,
    viewBox: "0 0 69 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.025 12.578c0-6.627 5.373-12 12-12h44c6.628 0 12 5.373 12 12v6c0 6.628-5.372 12-12 12h-44c-6.627 0-12-5.372-12-12v-6z",
    fill: "#C4CCE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.025 10.22l-4.875 5.358 4.875 5.358M45.025 10.22l4.875 5.358-4.875 5.358",
    stroke: "#fff",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.025 2.578h44v-4h-44v4zm54 10v6h4v-6h-4zm-10 16h-44v4h44v-4zm-54-10v-6h-4v6h4zm10 10c-5.522 0-10-4.477-10-10h-4c0 7.732 6.268 14 14 14v-4zm54-10c0 5.523-4.477 10-10 10v4c7.732 0 14-6.268 14-14h-4zm-10-16c5.523 0 10 4.477 10 10h4c0-7.732-6.268-14-14-14v4zm-44-4c-7.732 0-14 6.268-14 14h4c0-5.523 4.478-10 10-10v-4z",
    fill: "#C4CCE5"
  })));
}
export default __webpack_public_path__ + "media/virtualStagingSlider/rangeIcon-a67177c4.svg";
export { SvgRangeIcon as ReactComponent };